import { Sku } from './sku';

export enum ThirdPartyPlatform {
  UNKNOWN,
  YUNJI,
  XIAODENGTA,
}

export interface ThirdPartyOrder {
  id: number;
  happenedAt: Date;
  orderId?: number;
  originOrderId: string;
  paymentAt: Date;
  platform: ThirdPartyPlatform;
  raw: YunjiOrderRaw | XiaodengtaOrderRaw;
  status: number;
  result?: string;
  userId?: number;
}

export interface Order {
  id: number;
  userId: number;
  skus: Sku[];
  subtotal: number;
  discount: number;
  total: number;
  status: number;
  createdAt: Date;
  updatedAt: Date;
  invoices: OrderInvoice[];
  paySchedules: OrderPaySchedule[];
  paymentInvoices: PaymentInvoice[];
  products: OrderProduct[];
}

export interface OrderProduct {
  order: Order;
  orderId: number;
  productId: number;
}

export interface OrderInvoice {
  invoiceId: number;
  order: Order;
  orderId: number;
  orderPaySchedule: OrderPaySchedule;
  orderPayScheduleId: number;
}

export interface OrderPaySchedule {
  amount: number;
  dueAt: Date;
  invoices: OrderInvoice[];
  order: Order;
  orderId: number;
  stage: number;
  startAt: Date;
  status: number;
}

export interface PaymentInvoice {
  id: number;
  amount: number;
  status: number;
  paymentMethod: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface YunjiOrderRaw {
  orderId: string;
  tradeOrderId: string;
  payId: string;
  createTime: Date;
  modifyTime: Date;
  payTime: Date;
  status: number;
  receiverName: string;
  receiverProvince: string;
  receiverCity: string;
  receiverArea: string;
  receiverAddress: string;
  receiverMobile: string;
  receiverPhone: string | null;
  receiverZipCode: string;
  buyerComment: string | null;
  hasInvoice: number;
  orderDetail: {
    id: string;
    qty: number;
    skuNo: string;
    itemPrice: number;
    totalPrice: number;
    tradeOrderDetailId: string;
    returnStatus: number;
    substract: number;
    meetSubstract: number;
    mergePrice: number;
    coupon: number;
    taxPrice: number;
    logisticsPrice: number;
    orderLineNo: number;
    presellTime: Date | null;
    normName: string;
    unit: string;
    barcode: string;
    description: string;
    name: string;
  }[];
  idCardType: number;
  cardNumber: string;
  totalPrice: number;
  itemPrice: number;
  taxPrice: number;
  logisticsPrice: number;
  payEntName: string | null;
  payEntNo: string | null;
  payerName: string | null;
  payerCardId: string | null;
  payMoney: string | null;
  substract: number;
  meetSubstract: number;
  mergePrice: number;
  coupon: number;
}

export interface XiaodengtaOrderRaw {
  address: string; // 收货地址
  channelSn: string; // 渠道编号，小灯塔编号为：hllxiaodengta
  stampTime: number; // 发起请求时的时间戳，精确到秒
  userPhone: string; // 用户手机号（购课后的账号）
  orderSn: string; // 订单号
  orderTime: number; // 用户下单时间戳，精确到秒
  orderSuccessTime: number; // 用户成单时间戳，精确到秒
  orderPrice: number; // 订单实际支付价格（单位分）
  contactName: string; // 联系人姓名
  contactPhone: string; // 联系人手机号
  sign: string; // 签名字符串
}



// WEBPACK FOOTER //
// ./src/types/order.ts